export default __webpack_public_path__ + "static/media/background.2b352487.png";